import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountCostingAndBudgetingRoutingModule } from './account-costing-and-budgeting-routing.module';
import { CommonExternalModule } from '../../Common/common-external/common-external.module';
import { ProductionCostingComponent } from 'src/app/Module/Account/CostingAndBudgeting/production-costing/production-costing.component';
import { SharedModule } from 'src/app/shared/shared/shared.module';


@NgModule({
  declarations: [
    ProductionCostingComponent
  ],
  imports: [
    CommonModule,
    AccountCostingAndBudgetingRoutingModule,
    CommonExternalModule,
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AccountCostingAndBudgetingModule { }
